import { CheckCircleOutlined } from "@ant-design/icons";
import { Result, Typography } from "antd";
import { FunctionComponent } from "react";
const { Paragraph, Text } = Typography;

interface WelcomePageProps {}

const WelcomePage: FunctionComponent<WelcomePageProps> = () => {
  return (
    <Result status="success" title="Welcome to Gear!">
      <div>
        <Paragraph>
          <Text
            strong
            style={{
              fontSize: 16,
            }}
          >
            Next Steps:
          </Text>
        </Paragraph>
        <Paragraph>
          <CheckCircleOutlined style={{ color: "#52c41a" }} /> Install the{" "}
          <a href={process.env.EXTENSION_URL} target={"_blank"}>
            gear chrome extension
          </a>{" "}
          from{" "}
          <a href={process.env.EXTENSION_URL} target={"_blank"}>
            {process.env.EXTENSION_URL}
          </a>
        </Paragraph>
        <Paragraph>
          <CheckCircleOutlined style={{ color: "#52c41a" }} /> Once installed,
          restart your browser.
        </Paragraph>
        <Paragraph>
          <CheckCircleOutlined style={{ color: "#52c41a" }} /> Go to the
          extension icon in the top right corner:
          <a target={"_blank"} href="https://i.imgur.com/ZdqDp3y.png">
            https://i.imgur.com/ZdqDp3y.png
          </a>
        </Paragraph>
        <Paragraph>
          <CheckCircleOutlined style={{ color: "#52c41a" }} /> Find the icon
          that looks like a gear or a cog with a small person in it and click on
          the "Pin" icon.
        </Paragraph>
        <Paragraph>
          <CheckCircleOutlined style={{ color: "#52c41a" }} /> The Gear
          extension should now be visible in your browser as a red !-icon. Click
          on it and log in.
        </Paragraph>
        <Paragraph>
          <CheckCircleOutlined style={{ color: "#52c41a" }} /> You are now ready
          to start using gear!
        </Paragraph>
      </div>
    </Result>
  );
};

export default WelcomePage;
